import React, { useState } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { MailIcon } from 'lucide-react';
export const EmailSupport = () => {
  const [scrolled, setScrolled] = useState(false);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-7340">
      <Navbar scrolled={scrolled} data-id="element-7341" />
      <main className="pt-24 pb-20" data-id="element-7342">
        <div className="container mx-auto px-4 md:px-6" data-id="element-7343">
          <div className="max-w-3xl mx-auto bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm" data-id="element-7344">
            <div className="flex flex-col items-center text-center mb-8" data-id="element-7345">
              <div className="w-16 h-16 bg-[#2DB489]/10 rounded-full flex items-center justify-center mb-4" data-id="element-7346">
                <MailIcon className="h-8 w-8 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-7347" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-7348">
                Contact Us via Email
              </h1>
              <p className="text-xl text-gray-600 dark:text-[#B0C1BD]" data-id="element-7349">
                Please send your inquiries to{' '}
                <a href="mailto:support@yourdomain.com" className="text-[#2DB489] dark:text-[#4ED1A0] hover:underline" data-id="element-7350">
                  support@yourdomain.com
                </a>
              </p>
              <p className="mt-4 text-gray-600 dark:text-[#B0C1BD]" data-id="element-7351">
                We typically respond within 24 hours.
              </p>
            </div>
            <div className="bg-gray-50 dark:bg-[#1A3330] rounded-lg p-6 mb-6" data-id="element-7352">
              <h2 className="text-xl font-semibold mb-3 text-gray-800 dark:text-[#F8FAF9]" data-id="element-7353">
                What to Include in Your Email
              </h2>
              <ul className="space-y-2 text-gray-600 dark:text-[#B0C1BD]" data-id="element-7354">
                <li className="flex items-start" data-id="element-7355">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7356">
                    •
                  </span>
                  <span data-id="element-7357">Your account email address</span>
                </li>
                <li className="flex items-start" data-id="element-7358">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7359">
                    •
                  </span>
                  <span data-id="element-7360">Order number (if applicable)</span>
                </li>
                <li className="flex items-start" data-id="element-7361">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7362">
                    •
                  </span>
                  <span data-id="element-7363">Detailed description of your issue or question</span>
                </li>
                <li className="flex items-start" data-id="element-7364">
                  <span className="text-[#2DB489] dark:text-[#4ED1A0] mr-2" data-id="element-7365">
                    •
                  </span>
                  <span data-id="element-7366">Screenshots (if relevant)</span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-lg p-6 text-white" data-id="element-7367">
              <h2 className="text-xl font-semibold mb-2" data-id="element-7368">Support Hours</h2>
              <p className="mb-4 opacity-90" data-id="element-7369">
                Our email support team is available during the following hours:
              </p>
              <div className="space-y-1 mb-4" data-id="element-7370">
                <div className="flex justify-between" data-id="element-7371">
                  <span data-id="element-7372">Monday - Friday:</span>
                  <span data-id="element-7373">9:00 AM - 6:00 PM ET</span>
                </div>
                <div className="flex justify-between" data-id="element-7374">
                  <span data-id="element-7375">Saturday:</span>
                  <span data-id="element-7376">10:00 AM - 4:00 PM ET</span>
                </div>
                <div className="flex justify-between" data-id="element-7377">
                  <span data-id="element-7378">Sunday:</span>
                  <span data-id="element-7379">Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-7380" />
    </div>;
};